import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailSettingsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-settings',
	path: '/secure/admin/GlobalMailSettings([!%]?[\\w]*).jspa',
};
